import React from 'react';
import { QShieldPage } from './pages/QShieldPage';
export function App() {
  return <QShieldPage data-id="element-0" />;
}